import React, { Component } from "react"

import Button from "../button"
import EventFilterItem from "../event-filter-item"

class EventFilter extends Component {
  state = {
    programFilterDisplay: false,
    locationFilterDisplay: false,
    typeFilterDisplay: false,
  }
  programDisplayed = () => {
    const { programFilterDisplay } = this.state

    this.setState({
      programFilterDisplay: !programFilterDisplay,
      locationFilterDisplay: false,
      typeFilterDisplay: false,
    })
  }

  locationDisplayed = () => {
    const { locationFilterDisplay } = this.state

    this.setState({
      locationFilterDisplay: !locationFilterDisplay,
      programFilterDisplay: false,
      typeFilterDisplay: false,
    })
  }

  typeDisplayed = () => {
    const { typeFilterDisplay } = this.state

    this.setState({
      locationFilterDisplay: false,
      programFilterDisplay: false,
      typeFilterDisplay: !typeFilterDisplay,
    })
  }

  render() {
    const {
      href,
      onProgramChange,
      selectedProgram,
      programList,
      programsArr,
      countriesList,
      onCountryChange,
      selectedLocation,
      countriesArr,
      onTypeChange,
      typesList,
      selectedType,
      typesArr,
      onClick,
      showBtn,
    } = this.props

    const { programFilterDisplay, locationFilterDisplay, typeFilterDisplay } =
      this.state

    return (
      <div className="event-filter">
        <EventFilterItem
          title="Program"
          optionList={programList}
          onSelect={onProgramChange}
          selectedLabel={selectedProgram}
          selectedLength={programsArr.length}
          defaultSelectedArr={programsArr}
          filterWide={!showBtn}
          toggle={programFilterDisplay}
          displayed={this.programDisplayed}
        />
        <EventFilterItem
          title="Country"
          optionList={countriesList}
          onSelect={onCountryChange}
          selectedLabel={selectedLocation}
          selectedLength={countriesArr.length}
          defaultSelectedArr={countriesArr}
          filterWide={!showBtn}
          toggle={locationFilterDisplay}
          displayed={this.locationDisplayed}
        />
        <EventFilterItem
          title="Event type"
          optionList={typesList}
          onSelect={onTypeChange}
          selectedLabel={selectedType}
          selectedLength={typesArr.length}
          defaultSelectedArr={typesArr}
          filterWide={!showBtn}
          toggle={typeFilterDisplay}
          displayed={this.typeDisplayed}
        />
        <div
          className={`event-filter__item event-filter__item--btn ${showBtn ? "" : "event-filter__item__btn-mobile"}`}
        >
          <Button
            className="btn--cta event-filter__button"
            text="View events"
            iconName="ArrowRight"
            href={href}
            onClick={onClick}
          />
        </div>
      </div>
    )
  }
}

EventFilter.defaultProps = {
  location: "All",
  showBtn: true,
}

export default EventFilter
